import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/fotografo';

function Fotografo() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ nome: '', valor: '', data_ensaio: '', qtd_fotos: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ nome: '', valor: '', data_ensaio: '', qtd_fotos: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({ nome: item.nome, valor: item.valor, data_ensaio: item.data_ensaio, qtd_fotos: item.qtd_fotos });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Fotógrafo</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Nome" name="nome" value={form.nome} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Valor" name="valor" value={form.valor} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Data do Ensaio" name="data_ensaio" value={form.data_ensaio} onChange={handleChange} required sx={{ mr: 2 }} type="date" InputLabelProps={{ shrink: true }} />
          <TextField label="Qtd. Fotos" name="qtd_fotos" value={form.qtd_fotos} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && <Button onClick={() => { setEditId(null); setForm({ nome: '', valor: '', data_ensaio: '', qtd_fotos: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Data do Ensaio</TableCell>
            <TableCell>Qtd. Fotos</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.nome}</TableCell>
              <TableCell>{item.valor}</TableCell>
              <TableCell>{item.data_ensaio}</TableCell>
              <TableCell>{item.qtd_fotos}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default Fotografo;
